// src/pages/Holiday/AdminHolidayMasterList.js
import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline,Edit } from "@mui/icons-material";
import { Button, IconButton, Switch, Tooltip,FormControl,InputLabel,Select,MenuItem } from "@mui/material";

import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import HolidayMasterFormModal from "./AddHolidayMaster";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";

const AdminHolidayMasterList = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
    const [editHoliday, setEditHoliday] = useState(null);
  const gridRef = useRef();
  const [pageSize, setPageSize] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const handlePageSizeChange = (e) => setPageSize(Number(e.target.value));

  const { getHolidays } = MasterViewController();
  const { holidays } = useSelector((state) => state.master);
  const userType = localStorage.getItem("user_type");

  useEffect(() => {
    dispatch(getHolidays());
  }, [dispatch]);


  const handleEdit = (holiday) => {
    setEditHoliday(holiday);
    setShowModal(true);
  };

  const generateYears = () => {
  const current = new Date().getFullYear();
  const apiYears = Object.values(holidays)
    .flat()
    .map(h => h.year)                 // take year from each holiday
    .filter(y => !!y);                // ignore null/undefined
  const defaultYears = Array.from({ length: 7 }, (_, i) => current + 1 - i); // current+1 to current-5

  // Merge & sort descending
  const allYears = Array.from(new Set([...defaultYears, ...apiYears]));
  return allYears.sort((a, b) => b - a);
};

  const adminColumnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      pinned: "left",
    },
    {
      headerName: "SR No.",
      valueGetter: "node.rowIndex + 1",
      width: 90,
    },
    { headerName: "Occasion", field: "occasion", flex: 1, width: 200 },
    { headerName: "Date", field: "date", flex: 1 },
    { headerName: "Day", field: "day", flex: 1 },
    {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 160,
          maxWidth: 180,
          suppressSizeToFit: true,
          cellRenderer: (params) => (
            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
              <Tooltip title="Edit">
                <IconButton size="small" 
                onClick={() => handleEdit(params.data)}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          )
        }
  ];

  return (
    <div style={{ width: "100%", height: "100%", minHeight: "100vh", backgroundColor: "#f1f3f5" }}>
      {/* Header Controls */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        {/* Left: Export Button */}
        <div>
          {selectedRows.length > 0 && (
            <ExportButton
              gridRef={gridRef}
              fileName="holidays.xlsx"
              exportColumns={["occasion", "date", "day"]}
            />
          )}
        </div>

        {/* Right: PageSizeSelector + Add Holiday */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <PageSizeSelector
            pageSize={pageSize}
            onChange={handlePageSizeChange}
          />
          <div className="mt-2">
          <Button 
          variant="contained" 
          startIcon={<AddCircleOutline />} 
          onClick={() => setShowModal(true)}
          sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",                  
            }}
          >
            Add Holiday
          </Button>
          </div>
        </div>
      </div>

      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Holiday List</h3>
          </Col>
          <Col xs="auto">
            <FormControl size="small" style={{ minWidth: 100 }}>
              <InputLabel>Year</InputLabel>
              <Select
                value={selectedYear}
                label="Year"
                onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 3 * 48,
                      overflowY: "auto",
                    },
                  },
                }}
              >
                {generateYears().map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Col>
        </Row>
      </div>

      <div style={{ height: "75vh", width: "100%" }} className="ag-theme-material">
        <ReusableGrid
          columnDefs={adminColumnDefs}
          rowData={Object.values(holidays)
           .flat()
           .filter(h => h.year === selectedYear)}
          gridRef={gridRef}
          pagination={true}
          onGridReady={(params) => {
            gridRef.current = params.api;
            params.api.sizeColumnsToFit();
          }}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)} // ✅ Capture selected rows
        />
      </div>

      <HolidayMasterFormModal
        show={showModal}
        onHide={() => setShowModal(false)}
        initialData={editHoliday}
        selectedHolidays={[]}
        setSelectedHolidays={() => {}}
      />
    </div>
  );
};

export default AdminHolidayMasterList;
